import Image from 'next/image';
import { TeamData } from 'structure/home/components/FoundationTeam/types';
import { twMerge } from 'tailwind-merge';
import { Body2, Header5 } from 'structure/home/components/Typography';

interface TeamCardProps {
  className?: string;
  data: TeamData;
  onClick?: (item: TeamData) => void;
}

export const Card = (props: TeamCardProps) => {
  const { data, className, onClick } = props;

  return (
    <div
      onClick={() => onClick?.(data)}
      className={twMerge(
        'flex w-full flex-grow cursor-pointer flex-col items-center gap-4 rounded-3xl py-6 hover:bg-[#FFFFFF]/10',
        className
      )}
    >
      <div className='rounded-full bg-white'>
        <Image
          src={data.img}
          alt='teamImage'
          className='rounded-full'
          width={100}
          height={100}
        />
      </div>
      <div>
        <Header5 as='p' className='text-center font-bold'>
          {data.name}
        </Header5>
        <Body2 as='p' className='text-center'>
          {data.position}
        </Body2>
      </div>
    </div>
  );
};
